import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRightIcon } from "../../components/icons";
import "./Breadcrumbs.scss";

export interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <div className="breadcrumbs">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <span
            className={`sub-headline-s breadcrumb-item ${index === items.length - 1 ? "active" : ""}`}
            onClick={() => handleNavigation(item.path)}
          >
            {item.label}
          </span>
          {index < items.length - 1 && (
            <ChevronRightIcon className="breadcrumb-separator" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
